import * as z from "zod";

export const getTiktokAdsAudiences = {
  name: "getTiktokAdsAudiences" as const,
  input: z.object({ advertiserId: z.string() }),
  output: z.object({
    audiences: z.array(z.object({ id: z.string(), name: z.string() })),
  }),
};
